module.exports = __webpack_public_path__ + "static/media/Screenshot2.484092cf.png";